import { PAYMENT_METHODS } from "../../../constants/financial";

export const PAYMENT_METHOD_TABS = [
    { id: PAYMENT_METHODS.CASH, label: 'Dinheiro', icon: 'mdi-cash' },
    { id: PAYMENT_METHODS.PIX, label: 'Pix', icon: 'mdi-qrcode' },
    { id: PAYMENT_METHODS.DEBIT_CARD, label: 'Débito', icon: 'mdi-credit-card-check' },
    { id: PAYMENT_METHODS.CREDIT_CARD, label: 'Crédito', icon: 'mdi-credit-card' },
];

export const getMethodIcon = (id) => {
    switch (id) {
        case PAYMENT_METHODS.CASH: return 'mdi-cash';
        case PAYMENT_METHODS.PIX: return 'mdi-qrcode';
        case PAYMENT_METHODS.DEBIT_CARD: return 'mdi-credit-card-check';
        case PAYMENT_METHODS.CREDIT_CARD: return 'mdi-credit-card';
        default: return 'mdi-currency-usd';
    }
};

export const getMethodLabel = (id) => {
    const labels = {
        [PAYMENT_METHODS.CASH]: 'Dinheiro',
        [PAYMENT_METHODS.PIX]: 'Pix',
        [PAYMENT_METHODS.DEBIT_CARD]: 'Débito',
        [PAYMENT_METHODS.CREDIT_CARD]: 'Crédito'
    };
    return labels[id] || id;
};
